import { Box, IconButton, Tooltip } from "@mui/material";
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { BlockType } from "../new";
import { useEffect, useState } from "react";

const NewBlock: React.FC<{handleNewBlock(type: BlockType, file: File | undefined, imageUrl: string | undefined): void}> = ({ handleNewBlock }) => {

    const handleNewText = () => {
        handleNewBlock(BlockType.TEXT, undefined, undefined)
    }

    const [image, setImage] = useState<string | null>(null);
    const [file, setFile] = useState<File>();

    const handleImageChange = (event: any) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        setFile(file);
        reader.onloadend = () => {
            if(reader?.result)
                if (typeof reader?.result === 'string') {
                    setImage(reader?.result);
                }
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    };
    useEffect(() => {
        if(image)
        handleNewBlock(BlockType.IMAGE, file, image);
    }, [image]);

    return (
        <Box sx={{ display: "flex", justifyContent: "center"}}>
            <Tooltip title="Adicionar Texto">
                <IconButton color="warning" onClick={handleNewText}>
                    <TextIncreaseIcon/>
                </IconButton>
            </Tooltip>

            <Tooltip title="Adicionar Imagem">
                <>
                    <input
                        accept="image/*"
                        id="image-upload"
                        type="file"
                        style={{ display: 'none' }}
                        onChange={handleImageChange}
                    />
                    <label htmlFor="image-upload">
                        <IconButton color="warning" component="span">
                            <AddPhotoAlternateIcon/>
                        </IconButton>
                    </label>
                </>
            </Tooltip>
        </Box>
    )
}
export default NewBlock;